<template>
 <div class="loading-layer">
			<ul id="spinners">
				<li>
					<div id="preloader6">
						<span></span>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</li>
			</ul>
		</div>
</template>

<style scoped>
@import "../assets/css/loading.css";
</style>

<script>
export default {
  name: 'LoadingLayer'
}
</script>